import { ApolloCache } from "@apollo/client"

import {
  FloorTypename,
  ProductPositionTypename,
  ProjectTypename,
  RoomTypename
} from "shared/types/Project"

import { ClarificationRequestResourceType } from "../types/ClarificationRequest"

const resourceTypeToTypename: Record<ClarificationRequestResourceType, string> =
  {
    projects: ProjectTypename,
    floors: FloorTypename,
    rooms: RoomTypename,
    "project-positions": ProductPositionTypename
  }

export function updateResourceHasClarificationRequest(
  resourceType: ClarificationRequestResourceType,
  id: string,
  value: boolean,
  cache: ApolloCache<object>
) {
  const typename = resourceTypeToTypename[resourceType]
  const cacheId = cache.identify({ __typename: typename, id })
  if (!cacheId) return
  cache.modify({
    id: cacheId,
    fields: { hasClarificationRequest: () => value }
  })
}
